module.exports = __webpack_public_path__ + "img/gongsidalou.f7051c05.png";